import { render, staticRenderFns } from "./lossStudent.vue?vue&type=template&id=5495d7a5&scoped=true"
import script from "./lossStudent.vue?vue&type=script&lang=js"
export * from "./lossStudent.vue?vue&type=script&lang=js"
import style0 from "./lossStudent.vue?vue&type=style&index=0&id=5495d7a5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5495d7a5",
  null
  
)

export default component.exports